<template>

    <div>
      <v-toolbar
      :scroll-off-screen="!drawer"
      dark color="primary" fixed app
      :scroll-threshold="50"
      class="toolbar"
      id="main-menu-toolbar"
      >
        <v-toolbar-side-icon @click.stop="toggleMenu" class="hidden-md-and-up"></v-toolbar-side-icon>
        <v-toolbar-title>
          <div class="toolbar-title__wrapper">
          <router-link tag="a" :to="{name: 'accueil'}" class="toolbar__img-wrapper hidden-md-and-down">
            <!--<img class="toolbar__img" src="/static/assets/logo_final_blanc_nobg.png" alt="">-->
            <img class="toolbar__img" src="/static/assets/FINAL_COULEUR_FOND_BLANC_Rond.png" alt="">
          </router-link>

          </div>

          <router-link tag="a" :to="{name: 'accueil'}" class="toolbar__logo-text hidden-md-and-up">Basket Olympique Puechen </router-link>

        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-toolbar-items class="hidden-sm-and-down">

          <v-menu
            open-on-hover
            transition="slide-x-transition"
            bottom
            right offset-y
            v-for="(item, index) in navitems"
                :key="index">
            <v-btn
              slot="activator"
              color="white"
              dark
              flat
              :to="{name: item.linkName, params: item.params ? item.params : {}}"
              exact
              exact-active-class
            >
              {{ item.title }}
            </v-btn>


            <v-list 
            v-if="item.items.length > 0"
            dark
            class="menu__list"
            >
              <v-list-tile
                v-for="(subitem, index) in item.items"
                :key="index"
                @click=""
                :to="{name: subitem.linkName, params: subitem.params ? subitem.params : {} }"
                color="white"
                class="menu__list-tile"
              >
                <v-list-tile-title>{{ subitem.title }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

        </v-toolbar-items>
      </v-toolbar>
    </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
      data() {
          return {
          }
      },
      computed: {
        ...mapState ({
          drawer: state => state.navigation.sidebarIsActive,
          navitems: state => state.navigation.navitems
        })
      },
      methods: {
        ...mapActions('navigation',{
          toggleMenu: 'toggleSidebar' // map `this.add()` to `this.$store.dispatch('increment')`
        }),
        onLinkClicked(linkName) {
            $router.push({name: linkName});
        }
      }
  }
</script>

<style lang="scss">
.toolbar {
  z-index: 6;
}

.toolbar-title__wrapper {
  position: absolute;
  display: block;
  top: 0;
  text-align: center;

  background-color: transparent;
  color: #272727;

}
.toolbar__img-wrapper {
  position: relative;
  display: block;

  width: 140px;
  height: 100%;
  margin-top: 3px;

  .toolbar__img {
    position: relative;
    display: block;

    width: 100%;
    height: 100%;

    object-fit: contain;
    opacity: 0.95;

    filter: drop-shadow(1px 2px 5px rgba(#333, 0.8));
  }

}

.v-menu__content {
  .menu__list a.v-list__tile  {
    font-size: 0.95em;
      color: #B4B4B4;
    :hover,
    :active,
    :visited {
      color: #F4F4F4
    }
  }

  &.menuable__content__active .menu__list a.v-list__tile--active {
    color: #F4F4F4 !important;
    :link,
    :hover,
    :active,
    :visited {
      color: #F4F4F4
    }
  }
}


a.toolbar__logo-text  {
  text-decoration: none;
  color: white;
  padding: 1rem 1.8rem;

  &:hover {
    background-color: rgba(#fff, 0.1);

  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/TopHeader.vue